import React from 'react';
import ModelValidator from 'lib/ModelValidator';
import merge from 'lodash/merge';

export default function cardValidator(values) {
  const validator = new ModelValidator(values);

  return validator.getAllErrors({
    "cardholder_name":  ['required'],
    "termsAccepted":    ['accepted'],
  });
};
